import { combineEpics } from 'redux-observable';
// ---- external imports ----

import onLevelFailedEpic from './onLevelFailedEpic';
import onGameOverEpic from './onGameOverEpic';
// ---- local imports ----


export default combineEpics( 
    onLevelFailedEpic,
    onGameOverEpic
);
